import { RestClient } from '../lib/RestClient'

class ComunicadoService extends RestClient {
  constructor() {
    super('comunicado')
  }
  /**
   * Define anexos de uma atividade
   * @param {*} id Id da Atividade
   * @param {FileList} anexos Anexos
   */
  setAnexos(id, anexos, escola) {
    const form = new FormData()
    for (let anexo of anexos) {
      form.append('anexos[]', anexo, anexo.name)
    }

    return this.request({
      method: 'POST',
      url: `anexos/${id}?escola=${escola}`,
      data: form,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  setCapa(id, img, escola) {
    const form = new FormData()
    form.append('capa', img)
    return this.request({
      method: 'POST',
      url: `capa/${id}?escola=${escola}`,
      data: form,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  async getCapas(id, escola) {
    return this.request({
      method: 'GET',
      url: `capa/${id}?escola=${escola}`,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  async getAnexos(id, escola) {
    return this.request({
      method: 'GET',
      url: `anexos/${id}?escola=${escola}`,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  async desativarPorID(id, selectedEscola) {
    const response = await this.request.put(`desativar/${id}`, {
      escola: selectedEscola
    })
    return response.data
  }

  async desativar(id, statusDesativado, selectedEscola) {
    const response = await this.request.put(
      `status/${id}/${statusDesativado}`,
      {
        escola: selectedEscola
      }
    )
    return response.data
  }

  enviar(id, turma, params = {}) {
    return this.request({
      method: 'post',
      url: `enviar/${id}`,
      data: {
        turma
      },
      params
    })
  }

  async agendar(agenda, params = {}) {
    const response = await this.request.post('/agendar', agenda, {
      params
    })
    return response.data
  }

  async exibirComunicacaoAluno(id, params = {}) {
    const response = await this.request.get(`exibirComunicacaoAluno/${id}`, {
      params
    })
    return response.data
  }
  async exibirComunicacaoResponsavel(id, params = {}) {
    const response = await this.request.get(
      `exibirComunicacaoResponsavel/${id}`,
      {
        params
      }
    )
    return response.data
  }
}

export const Comunicado = new ComunicadoService()
